import { createContext } from 'react';

/**
 * Lets a finished ToolPreviewPanel hand its download / print / edit-again
 * buttons to the page's sticky action bar.
 *
 * ToolPageLayout provides `{ setResultActions }` when the page opts in (PDF
 * tools) and `null` otherwise; the panel registers
 * `{ primary, secondary }` while it shows a result and clears it after.
 */
export const ToolResultBarContext = createContext(null);
